import { BlockEditProps } from "@wordpress/blocks";
import type { BlockAttributes } from "./block.json";
import {
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import "../slider/swiper";
import ImageEditor from "../../../source/components/ImageEditor";

const ALLOWED_BLOCKS = ["core/paragraph"];

export default function NewsletterEditor(
  props: BlockEditProps<BlockAttributes>
) {
  const blockProps = useBlockProps({
    className: "newsletter alignfull position-relative",
  });
  const innerBlocksProps = useInnerBlocksProps(
    useBlockProps({
      className: "copy-xl",
    }) as unknown as Record<string, unknown>,
    {
      allowedBlocks: ALLOWED_BLOCKS,
      template: [
        [
          "core/paragraph",
          {
            content:
              props.attributes.content || "Wir halten dich auf dem Laufenden",
            className: "copy-xl",
          },
        ],
      ],
    }
  );

  return (
    <>
      <div {...blockProps}>
        <ImageEditor
          attributes={props.attributes}
          setAttributes={props.setAttributes}
          prefix="image"
          placeholderClassName="img-placeholder"
        />
        <div className="container h-100 position-relative">
          <div className="row align-items-center">
            <div className="col-xl-6">
              <div {...innerBlocksProps}></div>
            </div>
            <div className="col-0 col-xl-1"></div>
            <div className="col-xl-6 col-xxl-4 d-flex flex-column px-xxxl-5">
              <div className="justify-content-center mb-3">
                <div className="d-flex gap-2">
                  <div className="w-50">
                    <input
                      size={40}
                      className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required w-100"
                      aria-required="true"
                      aria-invalid="false"
                      placeholder="Vorname"
                      value=""
                      type="text"
                    />
                  </div>
                  <div className="w-50">
                    <input
                      size={40}
                      className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required w-100"
                      aria-required="true"
                      aria-invalid="false"
                      placeholder="Nachname"
                      value=""
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div className="justify-content-center mb-3">
                <div className="checkbox-wrapper">
                  <span
                    className="wpcf7-form-control wpcf7-checkbox"
                    id="newsletter_check"
                  >
                    <span className="wpcf7-list-item first last">
                      <input
                        type="checkbox"
                        name="datenschutz[]"
                        value="Ich möchte den Newsletter erhalten"
                      ></input>
                    </span>
                  </span>
                </div>
              </div>
              <input
                className="w-100"
                type="text"
                placeholder="E-Mail Adresse eingeben"
              />
              <div className="mt-3">
                <a className="button w-100">ABONNIEREN</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
